
import { Component, Emit, Prop, Vue, Model } from 'vue-property-decorator'
import { countryCascaderFilter } from '@xt/client/dataSource/china/index'
import { Cascader } from 'ant-design-vue'
import { Observer } from 'mobx-vue'
import { FormatLocationType } from '@xt/client/entities/location'

@Observer
@Component({
  components: {
    Cascader
  }
})
export default class FormCascader extends Vue {
  @Model('change', { type: Array<string> }) readonly value!: Array<string>
  @Prop({ required: true }) options: FormatLocationType | null

  countrySearch: {
    filter: (input: string, path: unknown[]) => boolean
  } = { filter: countryCascaderFilter }
  // 地区 配置

  isOpen: boolean = false

  get selectValue() {
    return this.value
  }

  set selectValue(val: string[]) {
    this.$emit('change', val)
  }

  // 同步展开状态
  onOpenChange(open: boolean) {
    this.isOpen = open
  }

  async created() {}

  mounted() {}

  updated() {}

  destroyed() {}
}
